<script>
  export let checked = false;
  export let label;
</script>

<div style="display: flex; margin-bottom: 10px;">
  <label class="switch">
    <input type="checkbox" bind:checked on:change />
    <span class="slider" />
  </label>

  <span class="switch-label">{label}</span>
</div>

<style>
  .switch {
    position: relative;
    display: inline-block;
    width: 35px;
    height: 15px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    border-radius: 34px;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    left: -2px;
    bottom: -2px;
    background-color: #efefef;
    -webkit-transition: 0.1s;
    transition: 0.1s;
    border-radius: 50%;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  }

  input:checked + .slider {
    background-color: #006699;
  }

  input:checked + .slider {
    box-shadow: 0 0 1px #006699;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
  }

  .switch-label {
    margin-left: 10px;
    margin-top: -2px;
  }
</style>
